var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 1.83333C13.5575 1.83333 16.6558 3.78583 18.1683 6.875C16.6558 9.96417 13.5667 11.9167 10.0833 11.9167C6.6 11.9167 3.51083 9.96417 1.99833 6.875C3.51083 3.78583 6.60917 1.83333 10.0833 1.83333ZM10.0833 0C5.5 0 1.58583 2.85083 0 6.875C1.58583 10.8992 5.5 13.75 10.0833 13.75C14.6667 13.75 18.5808 10.8992 20.1667 6.875C18.5808 2.85083 14.6667 0 10.0833 0ZM10.0833 4.58333C11.3483 4.58333 12.375 5.61 12.375 6.875C12.375 8.14 11.3483 9.16667 10.0833 9.16667C8.81833 9.16667 7.79167 8.14 7.79167 6.875C7.79167 5.61 8.81833 4.58333 10.0833 4.58333ZM10.0833 2.75C7.81 2.75 5.95833 4.60167 5.95833 6.875C5.95833 9.14833 7.81 11 10.0833 11C12.3567 11 14.2083 9.14833 14.2083 6.875C14.2083 4.60167 12.3567 2.75 10.0833 2.75Z",
    fill: "#897E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.97fac2104dd54bfc113307734da9c4c4.svg";
export { ForwardRef as ReactComponent };